import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import '@fortawesome/fontawesome-free/css/all.css'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)


Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('token') == null) {
            next({
                name: 'Login',
            })
        }
        if (!store.getters.loggedIn) {
            next({
                name: 'Login',
            })
        } else {
            next()
        }
    } else {
        if(localStorage.getItem('token') == null){
            next()
        }else{
            next({
                name: 'Home',
            })
        }
        
    }
})


new Vue({
    iconfont: 'fa',
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')